import { Fragment, useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";

const TARGET = new Date("2026-11-01T00:00:00+01:00").getTime();

const Countdown = () => {
  const { t } = useLang();
  const [diff, setDiff] = useState(TARGET - Date.now());

  useEffect(() => {
    const id = setInterval(() => setDiff(TARGET - Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (diff <= 0) return null;

  const units = [
    [Math.floor(diff / 86400000), t.hero.countdown.days],
    [Math.floor(diff / 3600000) % 24, t.hero.countdown.hours],
    [Math.floor(diff / 60000) % 60, t.hero.countdown.minutes],
    [Math.floor(diff / 1000) % 60, t.hero.countdown.seconds],
  ];

  return (
    <div data-testid="hero-countdown" className="mt-5 flex items-center gap-4 sm:gap-6">
      {units.map(([value, label], i) => (
        <Fragment key={label}>
          {i > 0 && <span aria-hidden="true" className="pb-4 font-serif text-gold/40">·</span>}
          <div className="flex flex-col items-start">
            <span className="font-serif text-2xl font-light tabular-nums text-parchment sm:text-3xl">
              {String(value).padStart(2, "0")}
            </span>
            <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.3em] text-parchment/50">{label}</span>
          </div>
        </Fragment>
      ))}
    </div>
  );
};

export default Countdown;
